import { cx } from './cx';

export interface SpinnerProps {
  label?: string;
  className?: string;
}

/** Standalone loading indicator (`Button`'s own busy state has its own, unexported, copy). */
export const Spinner = ({ label = 'Loading', className = '' }: SpinnerProps) => (
  <span
    role="status"
    aria-label={label}
    className={cx(
      'inline-block h-6 w-6 animate-spin rounded-full border-2 border-current border-t-transparent',
      className,
    )}
  />
);
